// extracted by mini-css-extract-plugin
export default {"input":"Input_input__wyUk-","error":"Input_error__BsWvk","error_msg":"Input_error_msg__b8ONr"};